export enum ObjectPreviewErrorTypeEnum {
  Forbidden = 'forbidden',
  NotAuthenticated = 'notauthenticated',
  NotFound = 'notfound',
  Unknown = 'unknown'
}
